import React, { FC } from 'react';
import { globalTheme, useMixin } from '@clds/component-theme';
import { Copy } from '@clds/icon';
import { Button, ButtonProps } from '@clds/button';
import { CopyToClipboard } from '@cld/copy-to-clipboard';

interface CopyButtonProps extends ButtonProps {
  onCopy?: () => void;
  contentToCopy: string;
}

export const CopyButton: FC<React.PropsWithChildren<CopyButtonProps>> = ({ onCopy, contentToCopy, ...rest }) => {
  const { contrastLow } = useMixin(globalTheme.palette);

  return (
    <CopyToClipboard tooltipBeforeText="Copy" tooltipAfterText="Copied" copiedValue={contentToCopy} onCopy={onCopy} tooltipPlacement="bottomRight">
      <Button variant="secondary" data-test-specifier="copy-snippet-button" leftSlot={<Copy color={contrastLow} />} {...rest} />
    </CopyToClipboard>
  );
};
